export class Result {
    isSuccess: boolean;
    errorCode: number;
    message:string;
    messageType:string;
    data:any;
    lookupData:any;
}